module.exports = __webpack_public_path__ + "img/battery-warning.c9a7db9b.svg";